var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-secondary-table-layout',{attrs:{"icon":"mdi-book-outline","card-title":_vm.$tc('document.name', 2)},scopedSlots:_vm._u([{key:"button",fn:function(){return [_c('base-new-outlined-button',{attrs:{"to":{
        name: 'document-new',
        query: { resourceType: _vm.resourceType, resourceId: _vm.resourceId }
      }}},[_vm._v(_vm._s(_vm.$tc('document.name', 1)))])]},proxy:true}])},[_c('DocumentIndexCards',{attrs:{"resource-id":_vm.resourceId,"resource-type":_vm.resourceType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }